<template>
    <v-container fluid class="guest-courses py-0">
        <v-row align="center" justify="center">
            <v-col class="div-banner" cols="12" style="background-color: #008dd4; height: 15vh;">
                <v-img src="/images/neumann-logo-contorno.png"></v-img>
            </v-col>
            <v-col cols="12" lg="7" md="6" sm="12" xs="12">
                <v-alert border="top" color="red lighten-2" dark style="margin-top: -4vh" class="elevation-2 text-center">
                    <strong>Los horarios están registrados utilizando la zona horaria estándar del centro (GMT-6)</strong>
                </v-alert>
            </v-col>
        </v-row>

        <v-row align="center" justify="center" style="margin-top: -2vh">
            <v-col cols="12" lg="7" md="6" sm="12" xs="12">
                <v-stepper v-model="stepper">
                    <v-stepper-header>
                        <v-stepper-step step="1">Inicio</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2">Idioma</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3">Cursos</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card>
                                <v-card-title style="display: block !important" class="text-center">Inscribete al curso que se adapte mejor a ti.</v-card-title>
                                <v-card-text class="py-0">
                                    <p class="text-center">En Instituto Neumann nos importa tu tiempo, por eso puedes seleccionar el curso que más se adapte a ti y a tus necesidades.</p>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn block color="#008dd4" @click="stepper = 2" dark>¡Comencemos!</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card>
                                <v-card-title>Selecciona el idioma</v-card-title>
                                <v-card-text>
                                    <v-list>
                                        <v-list-item-group mandatory v-model="language_id" active-class="blue--text text--darken-4">
                                            <template v-for="language in languages">
                                                <v-list-item :key="language.id" :value="language.id" @click="stepper = 3">
                                                    <template v-slot:default="{ active }">
                                                        <v-list-item-avatar size="60">
                                                            <v-img :src="language_image_url+language.image"></v-img>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ language.language }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card>
                                <v-card-title>Selecciona tu curso</v-card-title>    
                                <v-card-text>
                                    <v-skeleton-loader type="card" :hidden="!skeleton_loading"></v-skeleton-loader>
                                    <template v-if="courses.length > 0">
                                        <v-card v-for="(course, index) in order_courses" :key="index" class="mb-3" outlined>
                                            <v-card-text class="py-0 px-0">
                                                <v-container class="py-0 px-0" fluid>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" lg="2" md="2" sm="12" xs="12" class="text-center align-center" style="background-color: #008dd4">
                                                            <v-container fill-height class="px-0">
                                                                <v-row>
                                                                    <v-col>
                                                                        <h3 class="py-2 white--text">Inicio : {{ course.schedule[0].start_time }}</h3>
                                                                        <v-divider dark></v-divider>
                                                                        <h3 class="py-2 white--text">Fin : {{ course.schedule[0].end_time }}</h3>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-col>
                                                        
                                                        <v-col class="px-2 py-2" cols="12" lg="9" md="9" sm="12" xs="12">
                                                            <v-list-item-title>{{ course.name }}</v-list-item-title>
                                                            <v-list-item-subtitle class="mt-4">Nivel : <strong>{{ course.level.name }}</strong></v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4">Lugares disponibles : <strong>{{ course.spaces }}</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 1">Días : <strong>Lunes, Miércoles y Viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 2">Días : <strong>Martes y Jueves</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 3">Días : <strong>Sábados</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id >= 4">Días : <strong>Lunes a viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4"><strong>Hora estándar del centro (GMT-6)</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4">Fecha tentativa de inicio : <strong>{{ course.date }}</strong> </v-list-item-subtitle>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions class="py-0 px-0">
                                                <v-btn block text tile @click="redirect(course)">Seleccionar curso</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                    <v-card v-else outlined>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon x-large style="font-size: 4rem">mdi-emoticon-sad-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>Sin cursos disponibles</v-list-item-title>
                                                    <v-list-item-subtitle>Lamentablemente no tenemos cursos disponibles.</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text color="#000" @click="() => { stepper = 2; skeleton_loading = true }">Atrás</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fixed bottom right fab class="mb-10" v-bind="attrs" v-on="on" x-large color="red lighten-2" dark @click="waiting_list = !waiting_list">
                    <v-icon>mdi-calendar-search</v-icon>
                </v-btn>
            </template>
            <span>¿Buscas otro horario?</span>
        </v-tooltip>

        <v-dialog v-model="waiting_list" max-width="800">
            <v-card>
                <v-card-title>Lista de espera</v-card-title>
                <v-card-text>
                    <v-card-subtitle class="py-0">Ingresa la información requerida y nosotros le notificaremos cuando nuevos cursos estén disponibles.</v-card-subtitle>
                    <v-container>
                        <v-row justify="center" align="center">
                            <v-col cols="12">
                                <v-form ref="waiting_list_form">
                                    <v-text-field v-model="waiting_list_item.name"  :rules="[rules.required]" filled label="Nombre(s)"></v-text-field>
                                    <v-text-field v-model="waiting_list_item.email" :rules="[rules.required, rules.email]" filled @keydown.space.prevent label="Correo electrónico"></v-text-field>
                                    <v-text-field v-model="waiting_list_item.start_time" type="time" filled label="Hora de inicio (24 hrs)"></v-text-field>
                                    <v-select v-model="waiting_list_item.level_id"  :rules="[rules.required]" :items="levels_a" item-text="name" item-value="id" label="Nivel buscado" filled></v-select>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="waiting_list = false">cancelar</v-btn>
                    <v-btn color="primary" @click="waiting_list_register">REGISTRARME</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

import iziToast from 'izitoast'
const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

export default {
    props:['languages','levels','levels_a'],
    data: () => ({
        modality:"",
        tabs:"",
        courses_url:"/courses-available",
        language_image_url:"/storage/langs_disk/",
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",
        modalities:[
            { modality_id: 1, text: 'Lunes, Miércoles y Viernes' },
            { modality_id: 2, text: 'Martes y Jueves' },
            { modality_id: 3, text: 'Sábados' }
        ],
        courses: [],
        overlay:true,
        stepper:1,
        language_id:"",
        age:3,
        modality_id:"",
        level_id:"",
        skeleton_loading:false,
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido'
        },
        waiting_list:false,

        waiting_list_item:{
            name:"",
            email:"",
            level_id:"",
            start_time:"",
        }
    }),

    watch:{
        stepper:function(val){
            val === 3 ? this.getCourses() : ''
        }
    },

    computed:{
        order_courses:function(){
            let order_courses = []
            for(let course of this.courses){
                course.date = course.start_date.split('-').reverse()
                course.date[1] = meses[parseInt(course.date[1])-1]
                course.date = course.date.join('/')
                course.spaces = course.student_limit - course.number_students <= course.rm_students ? course.student_limit - course.number_students : course.rm_students
                order_courses.push(course)
            }

            return order_courses
        },
    },

    methods:{
        getCourses: function(){
            let data = {}
            let modalities = []
            data.language_id = this.language_id

            if(this.age == 1) modalities.push(4);
            if(this.age == 2) modalities.push(5);

            if(this.age > 2){
                modalities = []
                modalities.push(1,2,3)
            }

            data.modalities = modalities

            axios.get(this.courses_url, { params: data }).then(response => {
                this.courses = response.data.courses
                this.skeleton_loading = false

            }).catch(error => { console.log(error) });
        },

        redirect:function(course){
            window.location = '/register?course_id='+course.folio;
        },

        waiting_list_register:function(){
            if(this.$refs.waiting_list_form.validate()){
                let data = {}
                data.name       = this.waiting_list_item.name
                data.email      = this.waiting_list_item.email
                data.level_id   = this.waiting_list_item.level_id
                data.start_time = this.waiting_list_item.start_time


                axios.post("/waiting_list/store", data).then(response => {
                    this.waiting_list = false
                    iziToast.success({
                        title:"Correcto",
                        message:"Registrado a lista de espera correctamente",
                        position:"topRight"
                    })
                    this.$refs.waiting_list_form.reset()
                }).catch(error => {
                    this.$refs.waiting_list = false
                    this.$refs.waiting_list_form.reset()

                    console.log(error)
                })
                
            }
        }
    }
}
</script>